import type { FC, ReactElement, ReactNode } from "react";

interface SkeletonLoaderProps {
  isLoading: boolean;
  children?: ReactNode;
  className?: string;
}

const SkeletonLoader: FC<SkeletonLoaderProps> = ({
  isLoading,
  children,
  className,
}) => {
  if (isLoading || !children) {
    return (
      <div className={`animate-pulse bg-gray-200 rounded ${className ?? ""}`} />
    );
  }

  return children as ReactElement;
};

export default SkeletonLoader;
